import { API_VERSION } from 'constants/api'
import { getClientAndAPIKey } from 'utils/actionsHelper'

export const STORE_STATS_REQUEST = 'STORE_STATS_REQUEST'
export const STORE_STATS_SUCCESS = 'STORE_STATS_SUCCESS'
export const STORE_STATS_FAILURE = 'STORE_STATS_FAILURE'

export const STORE_CLIENT_INFO_REQUEST = 'STORE_CLIENT_INFO_REQUEST'
export const STORE_CLIENT_INFO_SUCCESS = 'STORE_CLIENT_INFO_SUCCESS'
export const STORE_CLIENT_INFO_FAILURE = 'STORE_CLIENT_INFO_FAILURE'

export const GET_WEB_RTC_STATS_REQUEST = 'GET_WEB_RTC_STATS_REQUEST'
export const GET_WEB_RTC_STATS_SUCCESS = 'GET_WEB_RTC_STATS_SUCCESS'
export const GET_WEB_RTC_STATS_FAILURE = 'GET_WEB_RTC_STATS_FAILURE'

export function storeRoomStats(statsReport) {
  const { client } = getClientAndAPIKey()

  return {
    types: [
      STORE_STATS_REQUEST,
      STORE_STATS_SUCCESS,
      STORE_STATS_FAILURE
    ],
    method: 'POST',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/web_rtc_stats`,
    body: {
      data: statsReport
    }
  }
}

export function storeClientInfo(clientInfo) {
  const { client } = getClientAndAPIKey()

  return {
    types: [
      STORE_CLIENT_INFO_REQUEST,
      STORE_CLIENT_INFO_SUCCESS,
      STORE_CLIENT_INFO_FAILURE
    ],
    method: 'POST',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/client_info`,
    body: {
      ...clientInfo
    }
  }
}

export function getWebRtcStats(visitId, token, onFailure = () => {}) {
  return {
    types: [
      GET_WEB_RTC_STATS_REQUEST,
      GET_WEB_RTC_STATS_SUCCESS,
      GET_WEB_RTC_STATS_FAILURE
    ],
    method: 'GET',
    url: `${process.env.GVS_URL}/api/web_rtc_stats/${visitId}`,
    basicAuth: token,
    onFailure
  }
}
